import { TAffiliation } from '@timeedit/types';

/**
 * Builds a draft copy of an affiliation suitable for the "new affiliation"
 * flow: keeps the full payload, prefixes the label with "[Copy] ", and clears
 * server-assigned fields (`_id`, `id`, `createdAt`, `updatedAt`) plus
 * `priority` (per-record ordering — the copy gets its own slot on save) so
 * the backend treats the result as a fresh record on submit.
 */
export const buildAffiliationCopy = (source: TAffiliation) => ({
  ...source,
  label: `[Copy] ${source.label}`,
  _id: undefined,
  id: undefined,
  updatedAt: undefined,
  createdAt: undefined,
  priority: undefined,
});
